export default __webpack_public_path__ + "a4d51a8a58d36f575397241c592c90aa.png";